module.exports = __webpack_public_path__ + "static/glowworm-79d79f1e02e4a11f6f1cb4e082cfb2ac.png";